var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "scholar-search" }, [
    _c("div", { staticClass: "content", staticStyle: { flex: "1" } }, [
      _vm.$route.name === "scholarSearch"
        ? _c("div", { staticClass: "infor" }, [
            _c(
              "h1",
              { staticClass: "title" },
              [
                _c("scholarIcon", {
                  attrs: { width: "55px", fill: "#ffffff" },
                }),
                _c("span", [_vm._v("专家查询")]),
              ],
              1
            ),
            _c("p", { staticClass: "tips" }, [
              _vm._v("用于分析某位学者画像及成果发表情况"),
            ]),
            _c(
              "div",
              { staticClass: "search-box" },
              [
                _c("textareaComp", {
                  ref: "textAreaRef",
                  attrs: { "rows-number": 4 },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "recommends-list" },
              _vm._l(_vm.recommendData, function (item, index) {
                return _c(
                  "p",
                  {
                    key: index,
                    staticClass: "item",
                    on: {
                      click: function ($event) {
                        return _vm.handleClickRecommend(item)
                      },
                    },
                  },
                  [
                    item.type === "1"
                      ? _c("scholarIcon", {
                          attrs: {
                            width: "22px",
                            height: "22px",
                            fill: "#2F70FF",
                          },
                        })
                      : _vm._e(),
                    item.type === "2"
                      ? _c("questionIcon", {
                          attrs: { width: "18", height: "18", fill: "#14D07A" },
                        })
                      : _vm._e(),
                    item.type === "3"
                      ? _c("literatureIcon", {
                          attrs: { width: "16", height: "16", fill: "#DDA726" },
                        })
                      : _vm._e(),
                    _c("span", [_vm._v(_vm._s(item.question))]),
                  ],
                  1
                )
              }),
              0
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading",
                  },
                ],
                staticClass: "recommends-scholar",
              },
              [
                _c("h3", [_vm._v("为您推荐")]),
                _c("SearchScholarList", {
                  ref: "SearchScholarList",
                  attrs: {
                    "person-list": _vm.talentData,
                    "city-type": _vm.talentLocationValue,
                  },
                }),
              ],
              1
            ),
          ])
        : _c("div", { staticClass: "history-list" }, [_c("historyChat")], 1),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }